module.exports = __webpack_public_path__ + "static/the-weekend-ac9b230d0d1e984e09989689ef9f6de8.png";